"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.resolveRelativePath = function (url, path) {
    var splittedUrl = url.split('/').filter(function (i) { return i !== ''; });
    var splittedPath = path.split('/').filter(function (i) { return i !== ''; });
    var pathLevelUpCount = 0;
    while (pathLevelUpCount < splittedPath.length && splittedPath[pathLevelUpCount] === '..') {
        pathLevelUpCount += 1;
    }
    var slicedUrl = splittedUrl.slice(0, splittedUrl.length - pathLevelUpCount);
    var slicedPath = splittedPath.slice(pathLevelUpCount, splittedPath.length);
    var result = slicedUrl.concat(slicedPath);
    return "/" + result.join('/');
};
exports.prefixPath = function (prefix, path) {
    if (!path)
        return prefix;
    var pathArray = Array.isArray(path) ? path : [path];
    return pathArray.map(function (p) { return "" + prefix + p; });
};
